import { getDefaultEstateState } from '../estate/index';
import estateStoreMutations from '@constans/store/estate/estateStoreMutations';
const mutations = {
    [estateStoreMutations.RESET_STATE]: (state) => Object.assign(state, getDefaultEstateState()),
    [estateStoreMutations.SET_ESTATE_LIST]: (state, array) => {
        state.list = array.estates;
    },
    [estateStoreMutations.SET_PRELOAD_CREATE]: (state, create) => state.payload = Object.assign(state.payload, create),
    [estateStoreMutations.SET_SINGLE_ESTATE_LIST]: (state, estate) => state.single = estate,
    [estateStoreMutations.SET_METHOD]: (state, method) => state.method = method,
    [estateStoreMutations.CHANGE_STATE]: (state, field) => {
        Object.keys(field).forEach(key => {
            const currentState = field.base !== undefined ? state[field.base] : state;
            // Do not save the "key base" in state.
            if (key !== 'base') {
                currentState[key] = field[key];
            }
        });
    },
    [estateStoreMutations.SET_USER]: (state, user) => {
        const { agent_id, coaddress, contact_person } = user;
        if (agent_id) {
            state.payload.agent_id = agent_id;
        }
        if (coaddress) {
            state.payload.coaddress = coaddress;
        }
        state.payload.contact_person = contact_person;
    },
    [estateStoreMutations.SET_FORM_PROPS]: (state, data) => {
        const propIds = state.payload.props_ids;
        data.forEach((item) => {
            const propItem = propIds[item.key];
            if (propItem) {
                propItem.forEach((propId) => {
                    const cell = item.data.find((propItem) => propItem.id === propId);
                    if (cell) {
                        cell.property_value = true;
                    }
                });
            }
            state.related_prop[item.key] = item.data;
        });
    },
    [estateStoreMutations.SET_PROP_IDS]: (state, obj) => {
        const propIds = { ...state.payload.props_ids };
        const relatedPropsIds = { ...state.related_prop };
        // Key does not exist, create it.
        if (!propIds[obj.key]) {
            propIds[obj.key] = [];
        }
        const checkboxToggleRelatedPropsId = () => {
            if (obj.type === 'checkbox' && relatedPropsIds[obj.key]) {
                const index = relatedPropsIds[obj.key].findIndex((item) => item.id === obj.id);
                if (index !== -1) {
                    relatedPropsIds[obj.key][index].property_value = !relatedPropsIds[obj.key][index].property_value;
                }
            }
        };
        /**
         * Remove the entite if no value, if value already exist, toggle value.
         * Append values based on field type, push or override
         */
        if (obj.id === null) {
            delete propIds[obj.key];
        }
        else if (propIds[obj.key].includes(obj.id)) {
            const index = propIds[obj.key].findIndex((i) => i === obj.id);
            propIds[obj.key].splice(index, 1);
            if (propIds[obj.key].length <= 0) {
                delete propIds[obj.key];
            }
            checkboxToggleRelatedPropsId();
        }
        else {
            if (obj.type === 'checkbox') {
                // state
                checkboxToggleRelatedPropsId();
                // Payload
                propIds[obj.key].push(obj.id);
            }
            else if (obj.type === 'select') {
                propIds[obj.key] = [obj.id];
            }
        }
        state.payload.props_ids = propIds;
        state.related_prop = relatedPropsIds;
    },
    [estateStoreMutations.UPDATE_STEP]: (state, step) => state.current_step = step,
    [estateStoreMutations.SET_ESTATE_ATTACHMENT_PAYLOAD]: (state, data) => {
        const type = data.id ? 'put' : 'create';
        // console.log('SET_ESTATE_ATTACHMENT_PAYLOAD', data);
        // console.log('attachment_update', state.attachment_update);
        // Grab by INDEX instead of ID
        if (type === 'create' && data.index !== null) {
            // console.log('create');
            const attachmentPayload = state.payload.attachment_payload;
            const file = attachmentPayload.find(file => file.index === data.index);
            if (!file) {
                attachmentPayload.push(data);
            }
            else {
                file.description = data.description;
                // Just assign if the payload contains the prop.
                if (data.file) {
                    file.file = data.file;
                }
                if (data.url) {
                    file.url = data.url;
                }
            }
        }
        if (type === 'put' && data.id !== null) {
            const existsInAttachmentPayload = state.payload.attachment_payload.find(file => file.index === data.index);
            if (existsInAttachmentPayload) {
                existsInAttachmentPayload.description = data.description;
            }
            else {
                // Grab by ID instead of INDEX
                const target = state.payload.attachment_update.find(file => file.id === data.id);
                if (target) {
                    target.description = data.description;
                }
                else {
                    state.payload.attachment_update.push({
                        id: data.id,
                        index: data.index,
                        description: data.description,
                    });
                }
            }
        }
    },
    [estateStoreMutations.UPDATE_ATTCHED_FILE]: (state, data) => {
        const holder = state.payload.attachment_files;
        data.forEach((item) => {
            const targetIndex = holder.findIndex(i => i.id === item.id);
            holder[targetIndex] = item;
        });
    },
    [estateStoreMutations.SET_UPLOADED_IMAGE]: (state, [data, index]) => {
        state.payload.attachment_files[index] = data;
        state.payload.file_ids[index] = data.id;
        // reset payload
        state.payload.attachment_payload = [];
    },
    [estateStoreMutations.REMOVE_ATTACHED_FILE]: (state, id) => {
        const indexAttachmentFile = state.payload.attachment_files.findIndex((file) => file.id === id);
        const indexFileId = state.payload.file_ids.findIndex((fileId) => fileId === id);
        if (indexAttachmentFile > -1 && indexFileId > -1) {
            state.payload.attachment_files.splice(indexAttachmentFile, 1);
            state.payload.file_ids.splice(indexFileId, 1);
        }
    },
    [estateStoreMutations.SET_STATE]: (state, estate) => {
        const findEstate = state.list.find(e => e.id === estate.id);
        if (findEstate) {
            findEstate.state = estate.state;
        }
    },
    [estateStoreMutations.SET_ADVERTISED_RENT]: (state, rent) => state.payload.advertised_rent = rent,
    [estateStoreMutations.SET_PREVIEWMODE]: (state, bool) => state.previewMode = bool
};
export default mutations;
